'use client';

import { createContext, useContext } from 'react';

/**
 * Inside a Work step the step header already groups its activity, so tool
 * clusters drop their own header and list their rows directly beneath it.
 */
export const ToolActivityClusterFlatContext = createContext(false);

export function useToolActivityClusterFlat(): boolean {
  return useContext(ToolActivityClusterFlatContext);
}
